//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import scroll from '@/mixins/scroll'
import AButton from './components/button/button.vue'
const Entities = require('html-entities').AllHtmlEntities

export default {
  components: { AButton },
  mixins: [scroll],
  data() {
    return {
      Entities,
    }
  },
  computed: {
    courseCards() {
      const courseCards = this.$getBullets('_courseCards')

      if (courseCards.length) {
        return courseCards.filter(
          (card) => card.url && card.url.includes('/math')
        )
      }

      return []
    },
  },
}
